import PropTypes from "prop-types"
import React, { useState } from "react"

import Button from "src/components/Button"
import HeadingSectionHeader from "src/components/Heading/HeadingSectionHeader"
import Tooltip from "src/components/Tooltip"

import { useTracker } from "src/hooks/use_tracker"

import GenerateInvoiceModal from "./GenerateInvoiceModal"

const BillingSection = ({ workOrder, workOrderSequentialId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const tracker = useTracker()

  if (!workOrder.serviceBillingEnabled) return null

  const canGenerate = workOrder.canGenerateInvoice

  const openModal = () => {
    tracker.trackEvent("work_orders:generate_invoice:opened", {
      workOrderSequentialId,
    })
    setIsModalOpen(true)
  }

  const generateButton = (
    <Button variant="primary" small onClick={openModal} disabled={!canGenerate}>
      Generate Invoice
    </Button>
  )

  return (
    <div className="mt-6 rounded-lg border p-5">
      <div className="mb-3 flex items-center justify-between">
        <HeadingSectionHeader>Billing</HeadingSectionHeader>
        {canGenerate ? (
          generateButton
        ) : (
          <Tooltip text="No jobs ready to invoice — mark a job complete first.">
            {generateButton}
          </Tooltip>
        )}
      </div>

      <div className="rounded-lg border border-dashed border-gray-300 py-8 text-center text-sm text-gray-500">
        Generate an invoice from this work order&rsquo;s completed jobs.
      </div>

      <GenerateInvoiceModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        workOrder={workOrder}
        workOrderSequentialId={workOrderSequentialId}
      />
    </div>
  )
}

BillingSection.propTypes = {
  workOrder: PropTypes.shape({
    serviceBillingEnabled: PropTypes.bool,
    canGenerateInvoice: PropTypes.bool,
    displaySequentialId: PropTypes.string,
    contact: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
    }),
    contactBoat: PropTypes.shape({ name: PropTypes.string }),
  }).isRequired,
  workOrderSequentialId: PropTypes.string.isRequired,
}

export default BillingSection
